export default "__VITE_ASSET__19c025c2__"